import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../../common/translation/translation.component';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { withRouter } from 'react-router-dom';
import {
    ORFButton
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../common/forms/order-request-form.component';
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { wirelineUpgradeCircuitActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-upgrade-circuit.reducer";
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { MAX_LENGTH, CIRCUIT_STATUS, SUBMIT_REQUEST_TITLE} from '../../../../../../constants/external-constants';
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { areArraysEqual } from "../../../../../../utils/helpers.utils";
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { ConfirmationNotificationModal } from '../../../../../common/modal/confirmation-modal.component';
import { Loading } from '../../../../../common/loading';
import { requestDetailsActions } from '../../../../../../store/external/request-reducer/request-details.reducer.js';


class WirelineUpdatePlanForm extends Component {
    constructor(props){
        super(props);
        this.getPlanDetailsModel = this.getPlanDetailsModel.bind(this);
        this.state = {
            showConModal: false,
            isSaving: false,
            title: "",
            checkboxValue: true,
            totalCost: 0,
            defaultCheckBoxValue: false,
            selectedCountry: "",
            selectedAddress: "",
            datatable: [
                {
                    "HeaderItem": [],
                    "dataItem": []
                }
            ],
            originalcircuitId: 0,
            originalcircuitCode: '',
            selectedPlanComponent: [],
            selectedPlanComponentId: [],
            selectedPlanComponentIndex: [],
            updateSelectedPlanComponent: [],
            error: false,
            resetCheckBox: false,
            isLoading: true
        }
    }

    async componentDidMount() {
        const { isUpdateRequest} = this.props.createRequest;
        const { requestDetail, onUpdateForm, fetchEmployeeByValue, fetchSubscriptionByValue,fetchSubscriptionByCircuitCode } = this.props;

        if (isUpdateRequest) {
            const selectedItem = requestDetail.requestData.Order;
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;

            if (selectedItem?.IsRequestedInBehalf) {
                await fetchSubscriptionByCircuitCode(currentCircuitCode, "CircuitCode", selectedItem.IsRequestedInBehalf);
                await fetchEmployeeByValue(requestDetail.requestData?.WireLineApprover?.Name, 'Name');
                await onUpdateForm().then(() => {
                    this.setState({
                        isLoading: false,
                        totalCost: requestDetail.requestData.Subscription.PlanDetails.TotalCost
                    });
                });
                const selectedPlanComponents = requestDetail.requestData.Subscription.PlanDetails.PlanComponents.map((item) => item.PlanComponentId);
                this.setState({
                    selectedPlanComponentId: selectedPlanComponents
                });
                const { planComponentList } = this.props.wirelineUpgradeCircuitFormA;
                var tmpselectedComponent = [];
                var tmpDataItem = planComponentList[0]?.dataItem?.length ? planComponentList[0].dataItem : [];
                var selectedPlanComponentIndex = [];

                for (let i = 0; i < tmpDataItem.length; i++) {
                    for (let k = 0; k < requestDetail.requestData.Subscription.PlanDetails.PlanComponents.length; k++) {
                        if (tmpDataItem[i].PlanComponentId == requestDetail.requestData.Subscription.PlanDetails.PlanComponents[k].PlanComponentId) {
                            tmpselectedComponent.push(requestDetail.requestData.Subscription.PlanDetails.PlanComponents[k]);
                            selectedPlanComponentIndex.push(i)
                        }
                    }
                }

                var dataTable = {
                    datatable: [
                        {
                            "HeaderItem": [...(planComponentList[0]?.HeaderItem ?? [])],
                            "dataItem": [...tmpDataItem],
                        }
                    ],
                    selectedPlanComponent: tmpDataItem.length === 1 ? [0] : tmpselectedComponent,
                    defaultCheckBoxValue: tmpDataItem.length === 1,
                    totalCost: requestDetail.requestData.Subscription.PlanDetails.TotalCost,
                    selectedPlanComponentIndex: selectedPlanComponentIndex,
                    updateSelectedPlanComponent: selectedPlanComponents
                }
            }

            else {
                await fetchSubscriptionByValue(currentCircuitCode);
                await fetchEmployeeByValue(requestDetail.requestData?.WireLineApprover?.Name, 'Name');
                await onUpdateForm().then(() => {
                    this.setState({
                        isLoading: false,
                        totalCost: requestDetail.requestData.Subscription.PlanDetails.TotalCost
                    });
                });
                const selectedPlanComponents = requestDetail.requestData.Subscription.PlanDetails.PlanComponents.map((item) => item.PlanComponentId);
                this.setState({
                    selectedPlanComponentId: selectedPlanComponents
                });
                const { planComponentList } = this.props.wirelineUpgradeCircuitFormA;
                var tmpselectedComponent = [];
                var tmpDataItem = planComponentList[0]?.dataItem?.length ? planComponentList[0].dataItem : [];
                var selectedPlanComponentIndex = [];

                for (let i = 0; i < tmpDataItem.length; i++) {
                    for (let k = 0; k < requestDetail.requestData.Subscription.PlanDetails.PlanComponents.length; k++) {
                        if (tmpDataItem[i].PlanComponentId == requestDetail.requestData.Subscription.PlanDetails.PlanComponents[k].PlanComponentId) {
                            tmpselectedComponent.push(requestDetail.requestData.Subscription.PlanDetails.PlanComponents[k]);
                            selectedPlanComponentIndex.push(i)
                        }
                    }
                }

                var dataTable = {
                    datatable: [
                        {
                            "HeaderItem": [...(planComponentList[0]?.HeaderItem ?? [])],
                            "dataItem": [...tmpDataItem],
                        }
                    ],
                    selectedPlanComponent: tmpDataItem.length === 1 ? [0] : tmpselectedComponent,
                    defaultCheckBoxValue: tmpDataItem.length === 1,
                    totalCost: requestDetail.requestData.Subscription.PlanDetails.TotalCost,
                    selectedPlanComponentIndex: selectedPlanComponentIndex,
                    updateSelectedPlanComponent: selectedPlanComponents
                }
            }
        }

        this.setState({ isLoading: false, ...dataTable, });
    }

    componentWillUnmount() {
        this.props.resetWirelineUpgradeCircuit();
        this.props.resetRequestData();
    }

    submitRequest = () => {
        this.setState({showConModal:true})
    }

    handleConfirmationModal = async (buttonType) => {
      
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems, setPlanDetailsModel} = this.props;

            setPlanDetailsModel(this.getPlanDetailsModel());
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest();
            let resultMessage = success.Message;
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title: "Success"
                });
                this.props.hideRequestModal();
                const { isUpdateRequest } = this.props.createRequest;
                resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
            }else {
                this.setState({
                    title: "Error"
                });
                resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
            }
            this.setState( prev => ({
                showConModal: !prev.showConModal,
                show: true,
                isSaving: false,
                message: resultMessage,
                })
            )
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    handleCloseNotif = () => {
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {
            this.props.history.goBack();
        } 
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    getCheckboxValue = (isChecked, index) => {
        const { planComponentList } = this.props.wirelineUpgradeCircuitFormA;
        const dataItem = this.state.datatable[0].dataItem;

        var selectedPlanComponent = [];
        var selectedPlanComponentIndex = [];
        if (!isChecked) {
            const planComponentIdToRemove = dataItem.find((item, i) => i == index);

            selectedPlanComponentIndex = this.state.selectedPlanComponentIndex.filter(function (item) {
                return item !== index;
            });
            selectedPlanComponent = this.state.selectedPlanComponent.filter(function(item) {
                return item.PlanComponentId !== planComponentIdToRemove.PlanComponentId;
            });

        } else {
            selectedPlanComponent = this.state.selectedPlanComponent;
            selectedPlanComponentIndex = this.state.selectedPlanComponentIndex;
            selectedPlanComponent.push(dataItem[index]);
            selectedPlanComponentIndex.push(index);
        }
        
        selectedPlanComponent.sort(function(a, b) {
            return a.ComponentCost - b.ComponentCost;
        });

        var totalCost = 0;
        var selectedPlanComponentId = [];
    
        selectedPlanComponent.forEach((i) => {
            const planComponent = planComponentList[0].dataItem.find(item => item.PlanComponentId === i.PlanComponentId);
    
            if (planComponent) {
                totalCost += parseFloat(planComponent.ComponentCost);  // Add the cost
                selectedPlanComponentId.push(i.PlanComponentId);  // Store the PlanComponentId
            }
        });
    
        this.setState({
            selectedPlanComponent: selectedPlanComponent,
            selectedPlanComponentId: selectedPlanComponentId,
            totalCost: totalCost,
            selectedPlanComponentIndex: selectedPlanComponentIndex,
            resetCheckBox: false,
        });
    };

    async handleChangePlan(value, propsName, objects, index) {
        const { wirelineUpgradeCircuitFormA } = this.props;
        await this.props.onPlanSelect(wirelineUpgradeCircuitFormA.newPlanId, value);
        const {planComponentList} = this.props.wirelineUpgradeCircuitFormA;

        var tmpDataItem = planComponentList[0]?.dataItem?.length ? planComponentList[0].dataItem : [];
        var dataTable = {
            datatable: [
                {
                    "HeaderItem": [...(planComponentList[0]?.HeaderItem ?? [])],
                    "dataItem": [...tmpDataItem],
                }
            ],
            selectedPlanComponent: tmpDataItem,
            selectedPlanComponentId: tmpDataItem.map(item => item.PlanComponentId),
            totalCost: tmpDataItem.reduce((sum, item) => sum + item.ComponentCost, 0),
            resetCheckBox: true,
        }
        
        this.setState({ ...dataTable, defaultCheckBoxValue : true });
    }

    getPlanDetailsModel() {
        var planDetailsModel = [];
        const dataItem = this.state.datatable[0].dataItem;
        
        this.state.selectedPlanComponent.forEach(i => {
            const matchingItem = dataItem.find(item => item.PlanComponentId === i.PlanComponentId);
            if (matchingItem) {
                planDetailsModel.push(matchingItem);
            }
        });

        return planDetailsModel;
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    render() {
        const {
            //form
            wirelineUpgradeCircuitFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
        } = this.props;

        const { subscriptionList, employeeList, isUpdateRequest, takeActionCircuitCode } = this.props.createRequest;
        const { formSubmitted, planOptions, vendorDetails, subscription, isResetLoading } = this.props.wirelineUpgradeCircuitRequest;
        const { requestDetail } = this.props;
        const { selectedPlanComponentId } = this.state;

        const sortedPlanComponentList = (wirelineUpgradeCircuitFormA.planComponentList || []).map(item => {

            if (item.HeaderItem && item.HeaderItem[0] && item.HeaderItem[0].ComponentName) {
                const newHeaderItem = [
                    {
                        ...item.HeaderItem[0],
                        ComponentName: {
                            ...item.HeaderItem[0].ComponentName,
                            name: wirelineUpgradeCircuitFormA.planName == "Other" ? "Other Features" : "Plan Component"  // Update the name value
                        }
                    }
                ];

                // Return a new object where HeaderItem is replaced with the updated array
                return {
                    ...item,
                    HeaderItem: newHeaderItem,  // Use the new array for HeaderItem
                    dataItem: item.dataItem.slice().sort((a, b) => (a.ComponentCost - b.ComponentCost))  // Sort dataItem
                };
            }
        });
        var isTheSamePlanComponentAsCurrentPlanInInventoryCircuit = areArraysEqual(subscription.CircuitPlanComponentId, selectedPlanComponentId);

        var isPlanNameOther = wirelineUpgradeCircuitFormA.planName == "Other" ? true : false;

        var requestPlanComponents, requestplanComponentIds;
        if (isUpdateRequest) {
            requestPlanComponents = requestDetail?.requestData?.Subscription?.PlanDetails?.PlanComponents ?? [];
            requestplanComponentIds = requestPlanComponents.map(component => component?.PlanComponentId ?? null);
        }

        const disableSubmitButton = (wirelineUpgradeCircuitFormA.circuitId == 0
            || wirelineUpgradeCircuitFormA.circuitCode == ''
            || wirelineUpgradeCircuitFormA.newPlanId == 0
            || wirelineUpgradeCircuitFormA.newPlanId == ''
            || wirelineUpgradeCircuitFormA.employeeName == ''
            || wirelineUpgradeCircuitFormA.wireLineApproverId == 0
            || wirelineUpgradeCircuitFormA.businessJustification == ''
            || selectedPlanComponentId === null || selectedPlanComponentId === undefined
            || selectedPlanComponentId.length === 0
            || isTheSamePlanComponentAsCurrentPlanInInventoryCircuit
            || formSubmitted || (
                 isUpdateRequest ?  (wirelineUpgradeCircuitFormA.businessJustification == requestDetail?.requestData.BusinessJustification?.BusinessJustification
                        && wirelineUpgradeCircuitFormA.additionalInformation == requestDetail.requestData?.BusinessJustification?.AdditionalInformation
                        && wirelineUpgradeCircuitFormA.circuitId == requestDetail.requestData?.CircuitId
                        && wirelineUpgradeCircuitFormA.wireLineApproverId == requestDetail.requestData?.WireLineApprover?.EmployeeId
                        && areArraysEqual(requestplanComponentIds, selectedPlanComponentId)) : false
              
            ))            


        if (this.state.isLoading) {
            return <Loading />
        }  

        return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal confirmation-blur-background notification-footer modal-text-bold'}
                />
                 <ConfirmationNotificationModal 
                    show={this.state.showConModal} 
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal confirmation-blur-background modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelineUpgradeCircuitFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                        {
                        !isResetLoading &&
                           <SearchSuggestions
                                value={wirelineUpgradeCircuitFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')}`}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                                errorMessage={this.toLocaleLanguage('error_subscription_not_exist')}
                                haveError={this.haveError}       
                                maxLength={MAX_LENGTH.limit_100}                        
                                />
                        }
                            {wirelineUpgradeCircuitFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                <span className={subscription.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{subscription.CircuitStatus} </span> <span>| </span>                                    
                                {subscription.VendorName ? subscription.VendorName : <Translation translationKey="no_vendor" />} <span>| </span>
                                {subscription.CircuitTypeName ? subscription.CircuitTypeName : <Translation translationKey="no_circuit_type_available" />} <span>| </span>
                                {subscription.SubCircuitTypeName ? subscription.SubCircuitTypeName : <Translation translationKey="no_sub_circuit_type_available" />}
                                </div>
                            }

                        </Col>
                    </Row>
                    <div>
                        {wirelineUpgradeCircuitFormA.circuitCode != '' &&
                            <div className="text-field-title-container">
                                <span className="order-detail-location-title"><Translation translationKey="current_plan" />:</span>
                                <span className="pb-15-pl-30 pl-10">
                                    {subscription.PlanName ? 
                                        <span>{subscription.PlanName} | {subscription.CurrencyName} {subscription.TotalCost}</span>
                                        : <span>N/A</span> 
                                    }
                                </span>
                            </div>
                        }

                        <div>
                            <h5 className="order-detail-location-title custom-margin-top-25 custom-margin-btm-15"><Translation translationKey="update_plan_details" /></h5>
                        </div>

                        <Row>
                            <Col xs={12} md={12} lg={12} className='required custom-margin'>
                                <CustomSearchableSelectWrapper                                        
                                    label={`${this.toLocaleLanguage('plan')}`}
                                    options={planOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.newPlanId'
                                    selected={wirelineUpgradeCircuitFormA.newPlanId}
                                    onChange={this.handleChangePlan.bind(this)}
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.limit_100}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>
                            { wirelineUpgradeCircuitFormA.newPlanId > 0 &&
                                
                                <>
                                <div className="price-plan-details-container">
                                    <div className="price-plan-left-details">
                                        <div className={`price-plan-header ${isPlanNameOther ? "":"required"}`}>  
                                            <span className='label'><Translation translationKey="plan_details"/></span>   
                                            {
                                                isPlanNameOther &&
                                                <div className="no-selected-planlist">
                                                    <span>{`${this.toLocaleLanguage('no_selected_plan')}`}</span>
                                                </div>
                                            }                    
                                        </div> 
                                        {
                                            isPlanNameOther &&
                                            <div className="price-plan-header required">
                                                <span className='label'><Translation translationKey="select_other_features"/></span>                            
                                            </div> 
                                        }
                                        <TableWithButton
                                            classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                                            datatable={sortedPlanComponentList}
                                            haveExternalDeleteBtn={false}
                                            haveCheckBox={true}
                                            enableCheckBox={true}
                                            getCheckboxValue={this.getCheckboxValue}
                                            currencyName={subscription.CurrencyName}
                                            defaultSelected={this.state.selectedPlanComponentIndex}
                                            defaultCheckBoxValue={this.state.defaultCheckBoxValue}
                                            resetCheckBox={this.state.resetCheckBox}
                                        />
                                        {
                                         isTheSamePlanComponentAsCurrentPlanInInventoryCircuit &&
                                            <div><span className='warning-label'>{`${this.toLocaleLanguage('warning_same_selected_plancomponent')}`}</span></div>
                                        }
                                    </div>                           
                                </div>

                                <div className="price-plan-total-cost-container">
                                    <div className="price-plan-header">
                                        <span><Translation translationKey="estimated_monthly_cost" /></span>
                                    </div>
                                    <div className="price-plan-total">
                                        <span>{vendorDetails.Currency}</span>
                                        <span>{parseFloat(this.state.totalCost).toFixed(2)}</span>
                                    </div>
                                </div>
                                </>            
                            }
                        <Row>
                           <Col xs={12} md={12} lg={12} className='required custom-margin'>
                            {
                                !isResetLoading &&
                                <SearchSuggestions
                                    value={wirelineUpgradeCircuitFormA.employeeName}
                                    label={`${this.toLocaleLanguage('approver')}`}
                                    propDisplay={'Name'}
                                    options={employeeList.length > 0 ? employeeList : ''}
                                    onChangeAction={onEmployeeSelect}
                                    searchAction={fetchEmployeeByValue}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_100}
                                    key={wirelineUpgradeCircuitFormA.circuitCode}
                                />
                            }
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required custom-margin'>
                                <TextArea 
                                    label={<Translation translationKey="business_justification" />}
                                    fieldProp='.businessJustification'
                                    value={wirelineUpgradeCircuitFormA.businessJustification}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                    maxLength={MAX_LENGTH.limit_500}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea 
                                    label={<Translation translationKey="additional_information" />}
                                    fieldProp='.additionalInformation'
                                    value={wirelineUpgradeCircuitFormA.additionalInformation}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                    maxLength={MAX_LENGTH.limit_1000}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                />
                            </Col>
                        </Row>

                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={<Translation translationKey="modal_close_cancel_button" />}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={<Translation translationKey="submit_request_button" />}
                                    variant={"primary"}
                                    type="submit"
                                    disabled = {disableSubmitButton}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter(connect(
    state => {
        const { wirelineUpgradeCircuitRequest, createRequest, translation, requestDetail } = state;
        const { wirelineUpgradeCircuitFormA} = state.form;
        return {
            wirelineUpgradeCircuitRequest
            , wirelineUpgradeCircuitFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineUpgradeCircuitActions
                , createRequestActions
                , requestLogActions
            ,requestDetailsActions),
            dispatch
        )
)(WirelineUpdatePlanForm));
